export default function (url, id, isAsync = true) {
  if (!url || !id) return
  let srcArr = document.getElementsByTagName('script')
  let hasLoaded = false

  for (let i = 0; i < srcArr.length; i++) {
    hasLoaded = srcArr[i].src === url
    if (hasLoaded) {
      document.getElementById(id).remove()
    }
  }

  const script = document.createElement('script')
  script.src = url
  script.id = id
  script.async = isAsync
  document.head.appendChild(script)
}
